import axios from 'axios';
import { clearStoredTokens, getStoredToken } from '@/lib/authStorage';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(config => {
  const token = getStoredToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const shouldSkipAuthRedirect = Boolean(error.config?.skipAuthRedirect);
    if (error.response?.status === 401 && !shouldSkipAuthRedirect) {
      clearStoredTokens();
      localStorage.removeItem('original_token');
      window.location.href = '/login';
    }
    // Plan limit reached → dispatch global event para que el dialog lo capture
    if (error.response?.status === 403) {
      const limitType = error.response.headers?.['x-limit-type'];
      if (limitType) {
        try {
          window.dispatchEvent(new CustomEvent('dealider:limit-reached', {
            detail: {
              limit_type: limitType,
              current: parseInt(error.response.headers?.['x-limit-current'] || '0', 10),
              max: parseInt(error.response.headers?.['x-limit-max'] || '0', 10),
              period: error.response.headers?.['x-limit-period'] || null,
              detail: error.response.data?.detail || '',
            },
          }));
        } catch (_) { /* noop */ }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
